import { message } from 'antd'
import serviceInterface from '../../services/service.interface'
import ActionType from '../action.types'

/*
Actions to be dispatched for regimen
- Inprogress
    action to dispatch incase of operation in progress
- set exercises
    action to dispatch incase to push exercises
*/

export function operationInProgress(isLoading) {
  return {
    type: ActionType.SCHED_INPROGRESS,
    isLoading,
  }
}

export function setExercises(exercises) {
  return {
    type: ActionType.SCHED_SET_EXERCISES,
    exercises,
  }
}

export function setSelected(selected) {
  return {
    type: ActionType.SCHED_SET_SELECTED,
    selected,
  }
}

export function getSchedule(patientid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.ScheduleService().getSchedule(patientid)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else dispatch(setExercises(data.schedule))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}

export function editSchedule({ patient, exercises }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      delete patient.surgery.__typename
      let data = await serviceInterface
        .ScheduleService()
        .editSchedule({ patient, exercises })
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else message.success(data.message)
      // Return the actual server response so the caller can decide
      // whether to navigate — returning `true` regardless of outcome
      // hid failures and caused double-toast UX where the page layer
      // added a second message based on a non-introspectable boolean.
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      return { error: true, message: err && err.message }
    }
  }
}
